module.exports = __webpack_public_path__ + "img/20.d9a8d40d.png";